import { render, staticRenderFns } from "./StudentClassCursus.vue?vue&type=template&id=4806afc7"
import script from "./StudentClassCursus.vue?vue&type=script&lang=js"
export * from "./StudentClassCursus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports